<template>
	<div id="forget_page">
		<div class="container">
			<v-logo></v-logo>
			<section class="forget_box_info">
				<h4 class="login_title color_5babf4">找回密码</h4>
				<div class="forget_form_box">
					<form action="#" method="">
						<div class="forget_user login_mbtm6">
							<label class="label_focus" for="forget_user_name">手机号码</label>
							<input type="text" @keyup.enter="updatePassword" class="form-control input_focus login_form" id="forget_user_name" v-model.trim="user.mobile" />
						</div>
						<div class="forget_yzm login_mbtm6">
							<label class="label_focus" for="forget_yzm1">验证码</label>
							<input type="text" @keyup.enter="updatePassword" class="form-control inline-block input_focus login_form" id="forget_yzm1" v-model.trim="user.yzm" />
							<div class="yzm_box inline-block">
								<img id="verifyImg2" @click="fleshVerify('verifyImg2')"></img>
							</div>
							<i class="glyphicon icon_reload" @click="fleshVerify('verifyImg2')" id="cloudFreshenTwo"></i>
						</div>
						<p class="tip_box ">
							<small class="tip_yz"></small>
						</p>
						<p class="login_btn_box">
							<a href="javascript:void(0);" class="btn btn_h btn_issue margin_r_7" @click="updatePassword()" id="cloudForgetPwd">确定</a>
							<router-link to="/login" class="color_9"><small>返回登录</small></router-link>
							|
							<router-link to="/register_index" class="color_308de2"><small>立即注册</small></router-link>
						</p>
					</form>
				</div>
			</section>
		</div>
	</div>
</template>

<script>

	export default {
		data() {
			return {
				user: {
					mobile: "",
					yzm: ""
				}
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				this.$inputFocus(".input_focus");
				this.fleshVerify('verifyImg2');
			})
		},
		methods: {
			fleshVerify(obj) {
				//重载验证码
				var verify = document.getElementById(obj);
				$(verify).attr('src', '/zklccloud/captcha.jpg?' + Math.random());
			},
			updatePassword() {
				var temp = this;
				var yanzm = this.user.yzm;
				if(this.user.mobile == '') {
					$(".tip_yz").text('手机号不能为空');
					return;
				} else if(yanzm.trim() == '') {
					$(".tip_yz").text('验证码不能为空');
					return;
				} else {
					$.ajax({
						url: "/zklccloud/queryYZM?checkMemo=" + yanzm.trim(),
						type: "post",
						contentType: 'application/json;charset=UTF-8',
						async: false,
						dataType: "json",
						success: function(m) {
							var yuz = m.resultCode;
							if(yuz == -1) {
								$(".tip_yz").text('验证码错误');
								temp.istrue = 1;
								temp.fleshVerify('verifyImg2');
							} else {
								temp.istrue = 0;
							}
						}
					})
				}
				if(temp.istrue == 0) {
					var formData = JSON.stringify(this.user);
					this.$http.post('/zklccloud/register/checkMob', formData, {
						emulateJSON: true
					}).then(function(m) {
						if(m.body.resultCode != 0) {
							/*var Num = "";
							for(var i = 0; i < 6; i++) {
								Num += Math.floor(Math.random() * 10);
							}
							this.user.memo = Num;*/
							var formData = JSON.stringify(this.user);
							this.$http.post('/zklccloud/register/zhaohuiMes', formData, {
								emulateJSON: true
							}).then(function(m) {
								if(m.body.resultCode == 0) {
									var mobile = m.body.content.mobile;
									var yzm = m.body.content.yzm;
									var memo = m.body.content.memo;
									this.$router.push({
										name: 'forget_password',
										params: {
											mobile: mobile,
											//memo: memo,
											yzm: yzm
										}
									});
								} else {
									$(".tip_yz").text('发送验证码失败,请联系管理员!');
									return;
								}

							})
						} else {
							$(".tip_yz").text('手机号不存在');
							return;
						}
					})
				}
			},
		}
	}
</script>

<style scoped>
	#forget_page {
		min-height: 100%;
		background: url(img/bg-forget.png) no-repeat center center;
		-webkit-background-size: cover;
		background-size: cover;
	}

	#forget_page .container {
		min-height: 500px;
	}

	.forget_box_info {
		width: 340px;
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// forget_page.vue?a7b15d20